/*eslint-env browser*/
import $ from "jquery"
import isLocalStorageSupported from "./local_storage_support.js"

let defaultSaveInterval = 60000
let defaultInactivityIntervalBeforeSave = 3000



function JsonSynchronizer (options = {}) {
    initServerProperties(this, options)
    initProperties(this, options)
    init(this)
}


function initProperties (synchro, {
    syncedCallback,
    inactivityIntervalBeforeSave = defaultInactivityIntervalBeforeSave,
    localStoragePrefix = "JsonSynchro",
    localStorageEnabled = true
}) {

    synchro.inactivityIntervalBeforeSave = inactivityIntervalBeforeSave

    synchro.syncedCallback      = syncedCallback
    synchro.localStorageEnabled = isLocalStorageSupported && localStorageEnabled
    synchro.localStoragePrefix  = localStoragePrefix
    synchro.data                = {}

}


function initServerProperties (synchro, {
    saveMinInterval = defaultSaveInterval,
    serverReadUrl,
    serverWriteUrl,
    serverWriteMethod = "PUT",
    paramsForServer = {},
    savedToServerCallback,
    fetchedFromServerCallback
}) {

    if (!serverWriteUrl && !serverReadUrl) {
        return
    }

    synchro.serverSaveMinInterval     = saveMinInterval

    synchro.serverReadUrl             = serverReadUrl

    synchro.serverWriteUrl            = serverWriteUrl
    synchro.serverWriteMethod         = serverWriteMethod

    synchro.paramsForServer           = paramsForServer

    synchro.savedToServerCallback     = savedToServerCallback
    synchro.fetchedFromServerCallback = fetchedFromServerCallback //FIXME used in Code N Slash (to access full object from server, not just the sources... but find a better way

}










//********************************* GET UPDATE DELETE


function getExistingKeysNotInData ({localStoragePrefix, data}) {
    let existingKeys = JSON.parse(localStorage[`${localStoragePrefix}_keys`] || "[]")
    let keys = []

    existingKeys.forEach(function (key) {
        let localStorageKey = `${localStoragePrefix}_key_${key}`
        if (!(key in data) && (localStorageKey in localStorage)) {
            keys.push(key)
        }
    })

    return keys
}


JsonSynchronizer.prototype.getData = function () {
    let dataDup = {}
    for (let key in this.data) {
        dataDup[key] = this.data[key]
    }
    return dataDup
}


JsonSynchronizer.prototype.getKey = function (key) {
    return this.data[key]
}


JsonSynchronizer.prototype.updateKey = function (key, source) {
    this.data[key] = source
    saveKeyIfNeeded(this)
}


JsonSynchronizer.prototype.deleteKey = function (key) {
    delete this.data[key]
    if (this.localStorageEnabled) {
        delete localStorage[`${this.localStoragePrefix}_key_${key}`]
    }
    saveKeyIfNeeded(this)
}









JsonSynchronizer.prototype.loadDataFromSource = function (data) {
    for (let dataKey in data) {
        this.data[dataKey] = data[dataKey]
    }
}





//********************************* CLEARING LOCAL MEMORY

JsonSynchronizer.prototype.clearLocal = function () {
    this.clearLocalStorage()
    this.data = {}
}




//********************************* LOCAL STORAGE

JsonSynchronizer.prototype.syncFromLocalStorage = function () {
    if (this.localStorageEnabled) {
        let keys = JSON.parse(localStorage[`${this.localStoragePrefix}_keys`] || "[]")
        keys.forEach((key) => {
            this.data[key] = localStorage[`${this.localStoragePrefix}_key_${key}`]
        })
        launchCallbacks(this, {origin: "localStorage"})
    } else {
        launchCallbacks(this, {origin: "null"})
    }

}


JsonSynchronizer.prototype.syncToLocalStorage = function () {
    if (this.localStorageEnabled) {
        let keys = getExistingKeysNotInData(this) //FIXME why ? not clear enough

        for (let key in this.data) {
            localStorage[`${this.localStoragePrefix}_key_${key}`] = this.data[key]
            if (keys.indexOf(key) === -1) {
                keys.push(key)
            }
        }

        localStorage[`${this.localStoragePrefix}_keys`] = JSON.stringify(keys)
    }
}


JsonSynchronizer.prototype.clearLocalStorage = function () {
    if (this.localStorageEnabled) {
        delete localStorage[`${this.localStoragePrefix}_version`]
        let keys = JSON.parse(localStorage[`${this.localStoragePrefix}_keys`] || "[]")
        delete localStorage[`${this.localStoragePrefix}_keys`]

        keys.forEach((key) => {
            delete localStorage[`${this.localStoragePrefix}_key_${key}`]
        })
    }
}






//********************************* SERVER

JsonSynchronizer.prototype.syncFromServer = function () {
    let that = this

    if (!this.serverReadUrl) {
        return
    }

    $.ajax({
        type:        "GET",
        url:         this.serverReadUrl,
        data:        this.paramsForServer,
        contentType: "application/json",
        dataType:    "json",

        success: function (data) {
            if (data) {
                handleSyncFromServerSuccess(that, data)
            } else {
                that.syncFromLocalStorage()
                that.syncToServer()
            }
        },

        error: function (data) {
            handleSyncFromServerError(that, data)
        }
    })
}


JsonSynchronizer.prototype.syncToServer = function () {

    if (!this.serverWriteUrl) {
        return
    }

    let data = JSON.stringify(dataToSend(this))

    $.ajax({
        type:        this.serverWriteMethod,
        url:         this.serverWriteUrl,
        data,
        contentType: "application/json",
        dataType:    "json",

        success: (returnedData) => {
            handleSyncToServerSuccessfulRequest(this, returnedData)
        },

        error: (jqXHR, DataStatus, error) => {
            handleRequestError(this, jqXHR, error)
        }
    })
}










//********************************* MISC PRIVATE FUNCTIONS


function init (synchro) {
    if (synchro.serverWriteUrl) {
        synchro.version = getLocalVersionNumber(synchro)
    } else {
        synchro.version = 0
    }

    if (synchro.serverReadUrl) {
        synchro.syncFromServer()
    } else {
        synchro.syncFromLocalStorage()
    }
}


function launchCallbacks (synchro, additionalData) {
    let dataDup = synchro.getData()

    if (synchro.syncedCallback) {
        synchro.syncedCallback(dataDup, additionalData)
    }

}


function saveKeyIfNeeded (synchro) {
    saveData(synchro, false)

    let time = (new Date()).getTime()

    clearTimeout(synchro.serverSaveTimeout)

    if (time - synchro.lastServerSave > synchro.serverSaveMinInterval) {
        saveData(synchro, true)
        synchro.lastServerSave = time
    } else {
        synchro.serverSaveTimeout = setTimeout(function () {
            saveData(synchro, true)
        }, synchro.inactivityIntervalBeforeSave)
    }
}



function saveData (synchro, onServer) {
    if (synchro.serverReadUrl) {
        synchro.version = (synchro.version || 0) + 1
        setLocalVersionNumber(synchro, synchro.version)
    }

    if (onServer) {
        synchro.syncToServer()
    } else {
        synchro.syncToLocalStorage()
    }
}


function launchAutoSave (synchro) {
    synchro.lastServerSave = (new Date()).getTime()
}







//********************************* SERVER


function handleSyncFromServerSuccess (synchro, data) {

    //FIXME used in code n slash, but find a better way
    if (synchro.fetchedFromServerCallback) {
        synchro.fetchedFromServerCallback(data)
    }

    if (getLocalVersionNumber(synchro) > data.version) {
        synchro.syncFromLocalStorage()
        synchro.syncToServer()
    } else {
        synchro.fullDataFromServer = data
        synchro.version = data.version
        synchro.loadDataFromSource(data.source)
        launchCallbacks(synchro, {origin: "server"})
    }
    launchAutoSave(synchro)
}


function handleSyncFromServerError (synchro) {
    console.warn("Data synchronization failed")
    synchro.syncFromLocalStorage()
    launchAutoSave(synchro)
}



function dataToSend ({version, data, paramsForServer}) {
    let toSend = {
        version,
        data
    }

    for (let paramKey in paramsForServer) {
        toSend[paramKey] = paramsForServer[paramKey]
    }

    return toSend
}


function handleSyncToServerSuccessfulRequest (synchro, data) {
    if (!("version" in data)) {
        handleNoVersionError(synchro, data)
    } else if (data.version < synchro.version) {
        handleLowVersionError(synchro, data)
    } else {
        handleSyncToServerSuccess(synchro, data)
    }
}


function handleSyncToServerSuccess (synchro, data) {
    if (synchro.savedToServerCallback) {
        synchro.savedToServerCallback(false, data)
    }
    synchro.version = data.version
    setLocalVersionNumber(synchro, data.version)
}


function handleNoVersionError (synchro, data) {
    if (synchro.savedToServerCallback) {
        synchro.savedToServerCallback({
            noVersionError: data
        })
    } else {
        console.warn("Server should have returned a version number. Data returned were :", data)
    }
}


function handleLowVersionError (synchro, data) {
    if (synchro.savedToServerCallback) {
        synchro.savedToServerCallback({
            lowVersionError: data
        })
    } else {
        console.warn(
            `server update issue : version number on server is ${data.version
            } and it should be greater or equal than local ${synchro.version}`
        )
    }
}


function handleRequestError (synchro, jqXHR, error) {
    if (synchro.savedToServerCallback) {
        synchro.savedToServerCallback({
            requestError: jqXHR
        })
    } else {
        console.warn(`server update issue : ${error}`)
    }
}






//********************************* VERSIONS


function getLocalVersionNumber (synchro) {
    if (synchro.localStorageEnabled) {
        return parseInt(localStorage[`${synchro.localStoragePrefix}_version`] || "0", 10)
    } else {
        return 0
    }
}

function setLocalVersionNumber (synchro, value) {
    if (synchro.localStorageEnabled) {
        localStorage[`${synchro.localStoragePrefix}_version`] = value
    }
}






export default JsonSynchronizer


